<template>
  <!-- Table Container Card -->
  <b-card id="page-services" no-body class="mb-0 p-2">
    <b-card-header
      class="pl-0 pr-0 d-flex align-items-between justify-content-center"
    >
      <b-col cols="12" md="4">
        <b-card-title
          ><h2>{{ $t(label("title")) }}</h2>
        </b-card-title>
      </b-col>
      <b-col v-if="canCreate" cols="12" md="8" class="d-none d-md-table">
        <b-col cols="12" class="d-flex align-items-between justify-content-end">
          <b-button id="tooltip-create" variant="primary" @click="onCreate">
            <feather-icon
              aria-label="Register"
              icon="PlusIcon"
              class="mr-25"
              size="18"
            />
            <span class="text-nowrap">{{ $t(label("register")) }}</span>
          </b-button>
        </b-col>
      </b-col>

      <b-col
        v-if="canCreate"
        cols="12"
        sm="12"
        md="8"
        class="d-md-none d-flex justify-content-end pt-2"
      >
        <b-button
          id="tooltip-create"
          variant="primary"
          @click="onCreate"
          class="btn-icon"
        >
          <feather-icon icon="PlusIcon" size="18" aria-label="Register" />
        </b-button>
      </b-col>
    </b-card-header>

    <Filterss
      :fields="fildsToFilters"
      :model="model"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
    />

    <!-- Table for larger devices -->
    <b-table
      id="services-table"
      responsive
      :head-variant="headVariant"
      :striped="striped"
      :bordered="bordered"
      :borderless="borderless"
      :outlined="outlined"
      :per-page="perPage"
      :busy="loading"
      :items="items"
      :fields="fields"
      class="d-none d-md-table shadow-sm !rounded"
    >
      <template #head()="data">
        <span class="text-black">{{
          $t(labelHeader(data.label.toLowerCase()))
        }}</span>
      </template>
      <template #cell(name)="data">
        <slot name="cell-name" :data="data">
          {{ data.item.name || "N/A" }}
        </slot>
      </template>
      <template #cell(price)="data">
        <slot name="cell-price" :data="data">
          {{ data.item.price ? data.item.price + " " + divisa : "N/A" }}
        </slot>
      </template>
      <template #cell(durationMinutes)="data">
        <slot name="cell-durationMinutes" :data="data">
          {{
            data.item.durationMinutes
              ? data.item.durationMinutes + ` ` + data.item.nameCategory
              : "N/A"
          }}
        </slot>
      </template>
      <template #cell(active)="data">
        <slot name="cell-active" :data="data">
          <div class="d-flex align-items-center">
            <b-badge pill :variant="tagsColor(data.item.active)">
              <span>{{
                $t(
                  label(data.item.active ? "status.active" : "status.inactive"),
                )
              }}</span>
            </b-badge>
          </div>
        </slot>
      </template>

      <template #cell(actions)="data">
        <feather-icon
          v-if="canShow"
          class="text-success mr-25 cursor-pointer"
          size="18"
          icon="FileTextIcon"
          @click="onShow(data.item.guid)"
        />

        <feather-icon
          v-if="canEdit"
          class="text-primary mr-25 cursor-pointer"
          size="18"
          icon="EditIcon"
          @click="onEdit(data.item.guid)"
        />

        <feather-icon
          v-if="canChangeStatus && data.item.active"
          v-b-tooltip.hover
          :title="$t(label('disable.action'))"
          class="text-warning cursor-pointer"
          size="18"
          icon="SlashIcon"
          @click="onInactive(data.item.guid)"
        />

        <feather-icon
          v-if="canChangeStatus && !data.item.active"
          v-b-tooltip.hover
          :title="$t(label('enable.action'))"
          class="text-success cursor-pointer"
          size="18"
          icon="CheckCircleIcon"
          @click="onActive(data.item.guid)"
        />
      </template>

      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle ml-50"></b-spinner>
          <strong>{{ $t("loading") }}...</strong>
        </div>
      </template>
    </b-table>
    <!-- List for mobile devices -->
    <div id="list-container" class="d-block d-md-none mt-1 list-container">
      <b-list-group>
        <b-list-group-item
          v-for="item in items"
          :key="item.guid"
          class="flex-column align-items-start border border-primary rounded mb-1"
        >
          <div class="d-flex w-100 justify-content-between m-0 p-0">
            <p style="margin-bottom: 0 !important">
              <strong> {{ item.name || "N/A" }}</strong>
            </p>

            <b-dropdown
              variant="link"
              no-caret
              class="chart-dropdown"
              toggle-class="p-0"
              right
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item v-if="canShow" @click="onShow(item.guid)">
                <div class="d-flex align-items-center justify-content-between">
                  {{ $t("show") }}
                  <feather-icon
                    class="text-success mr-25"
                    size="18"
                    icon="FileTextIcon"
                  />
                </div>
              </b-dropdown-item>
              <b-dropdown-item v-if="canEdit" @click="onEdit(item.guid)">
                <div class="d-flex align-items-center justify-content-between">
                  {{ $t("edit") }}
                  <feather-icon
                    class="text-primary mr-25"
                    size="18"
                    icon="EditIcon"
                  />
                </div>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="canChangeStatus && item.active"
                @click="onInactive(item.guid)"
              >
                <div class="d-flex align-items-center justify-content-between">
                  {{ $t(label("disable.action")) }}
                  <feather-icon
                    class="text-warning"
                    size="18"
                    icon="SlashIcon"
                  />
                </div>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="canChangeStatus && !item.active"
                @click="onActive(item.guid)"
              >
                <div class="d-flex align-items-center justify-content-between">
                  {{ $t(label("enable.action")) }}
                  <feather-icon
                    class="text-success"
                    size="18"
                    icon="CheckCircleIcon"
                  />
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <!-- <br /> -->
          {{ $t(labelHeader("duration")) }} :
          {{ item.durationMinutes || "N/A" }} min.
          <br />
          <!-- {{ $t(labelHeader("stock")) }} : {{ item.durationMinutes }} <br /> -->
          {{ $t(labelHeader("price")) }} : {{ item.price || "N/A" }} $ <br />
          {{ $t(labelHeader("active")) }} :
          <b-badge pill :variant="tagsColor(item.active)">
            <span>{{
              $t(label(item.active ? "status.active" : "status.inactive"))
            }}</span>
          </b-badge>
          <!-- {{ $t(labelHeader("active")) }} : {{ item.active ? 'Activo' : 'Inactivo'}}  <br /> -->
        </b-list-group-item>
        <b-list-group-item v-if="items.length == 0" class="text-center">
          {{ $t("notRegister") }}
        </b-list-group-item>
        <b-list-group-item v-if="loading" class="text-center">
          <b-spinner variant="success"></b-spinner>
        </b-list-group-item>
      </b-list-group>
    </div>
    <!-- pagination -->
    <div class="mx-2 d-none d-md-table">
      <b-row>
        <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">{{
              $t("perPage")
            }}</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              @change="handlePerPageChange"
              class="w-50"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          sm="12"
          md="10"
          lg="10"
          xl="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            @change="handlePageChange"
            first-number
            last-number
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  VBTooltip,
  BTooltip,
  BFormSelect,
  BAvatar,
  BFormGroup,
  BCardBody,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import {
  allServices,
  inactiveService,
  activeService,
} from "@core/api/request/services";
import { allCompanies } from "@core/api/request/company";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import Filterss from "../components/filters/Filterss.vue";
import { canAccess } from "@/security/permissions/permissionHelper";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    BAvatar,
    vSelect,
    Filterss,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data: () => ({
    model: "services",
    companyGuid: null,
    loading: false,
    totalRows: 0,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    hasNextPage: true,
    items: [],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    fields: [
      { label: "name", key: "name", sortable: true },
      { label: "price", key: "price", sortable: false },
      { label: "duration", key: "durationMinutes", sortable: false },
      { label: "active", key: "active", sortable: false },
      { label: "action", key: "actions", sortable: false },
    ],
    appliedFilters: {},
    showOptions: false,
  }),

  computed: {
    fildsToFilters() {
      return [
        {
          name: "name",
          placeholder: "name",
          type: "search",
          visible: true,
        },
        {
          name: "active",
          title: "active",
          placeholder: "active",
          type: "select",
          options: [
            {
              value: true,
              label: this.$t(this.label("tableFilter.activeOption")),
            },
            {
              value: false,
              label: this.$t(this.label("tableFilter.inactiveOption")),
            },
          ],
          visible: true,
          multiple: false,
          close: true,
        },
      ];
    },
    divisa() {
      return this.$store.state.appConfig.divisa || "USD";
    },

    canCreate() {
      return canAccess("Servicios", "creation");
    },
    canShow() {
      return canAccess("Servicios", "reading");
    },
    canEdit() {
      return canAccess("Servicios", "edition");
    },
    canChangeStatus() {
      return canAccess("Servicios", "elimination");
    },
  },

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.hasNextPage = true;
      this.currentPage = 1;
      this.items = [];
      this.loadData();
    },
  },
  created() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.loadData();
  },
  async mounted() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const params = this.chargeParams();
        const [servicesResp] = await Promise.all([allServices(params)]);

        // Procesamos Servicios
        const services = _.get(servicesResp, "data");
        this.items = services?.items || [];
        this.totalRows = services?.totalRows || 0;
        this.hasNextPage = services?.currentPage < services?.totalPages || 0;
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error.message);
      } finally {
        this.loading = false;
      }
    },
    async loadServicesInfinity() {
      if (!this.hasNextPage) return;
      try {
        this.loading = true;
        const params = this.chargeParams();
        allServices(params)
          .then((resp) => {
            const data = _.get(resp, "data", []);
            if (Array.isArray(data?.items)) {
              // Agregar nuevos elementos sin sobreescribir los existentes
              this.items = [...this.items, ...data?.items];
            }
            this.totalRows = data?.totalRows || 0;
            // Verificar si hay más páginas
            this.hasNextPage = data?.currentPage < data?.totalPages || false;
            this.loading = false;
          })
          .catch((error) => {
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
            console.error("Error loading products infinitely", error);
          });
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error cargando productos infinitamente", error.message);
      }
    },
    label(field) {
      return `pages.services.table.${field}`;
    },

    labelHeader(field) {
      return `pages.services.table.tableHeader.${field}`;
    },
    chargeParams() {
      const arrParams = [];
      arrParams.push(`page,${this.currentPage}`);
      arrParams.push(`rows,${this.perPage}`);
      arrParams.push(`guidCompany,${this.companyGuid}`);

      if (this.appliedFilters.name) {
        arrParams.push(`name,${this.appliedFilters.name}`);
      }

      if (typeof this.appliedFilters.active === "boolean") {
        arrParams.push(`active,${this.appliedFilters.active}`);
      }

      return getParams(arrParams);
    },
    async handleScroll() {
      const container = document.getElementById("list-container");
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadServicesInfinity();
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadData();
    },
    handlePerPageChange() {
      this.loadData();
    },
    validateFilters(filters) {
      // Validar nombre (no debe ser vacío ni contener solo espacios)
      if (filters.name && !filters.name.trim()) {
        console.error("El filtro de nombre no es válido.");
        return false;
      }

      return true;
    },
    applyFilters(filters) {
      if (this.validateFilters(filters)) {
        this.appliedFilters = filters;
        this.currentPage = 1;
        this.hasNextPage = true;
        this.loadData();
      } else {
        console.error("Filtros no aplicados debido a validaciones fallidas.");
      }
    },
    resetFilters() {
      console.log("Resetting filters");
      this.appliedFilters = {};

      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadData();
    },
    tagsColor(status) {
      if (status) return "light-success";
      else return "light-danger";
    },
    onCreate() {
      if (!this.canCreate) return;
      this.$router.push({
        name: "serviceCreate",
        params: { option: 1 },
      });
    },
    onShow(guid) {
      if (!this.canShow) return;
      this.$router.push({
        name: "serviceEdit",
        params: { option: 2, guid },
      });
    },
    onEdit(guid) {
      if (!this.canEdit) return;
      this.$router.push({
        name: "serviceEdit",
        params: { option: 3, guid },
      });
    },
    onInactive(guid) {
      this.changeServiceStatus(guid, "disable", inactiveService);
    },
    onActive(guid) {
      this.changeServiceStatus(guid, "enable", activeService);
    },
    async changeServiceStatus(guid, translationKey, serviceRequest) {
      if (!this.canChangeStatus) return;

      const result = await this.$swal({
        title: this.$t(this.label(`${translationKey}.confirmTitle`)),
        text: this.$t(this.label(`${translationKey}.confirmText`)),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t(
          this.label(`${translationKey}.confirmButton`),
        ),
        cancelButtonText: this.$t(this.label(`${translationKey}.cancelButton`)),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      });

      if (!result.value) {
        if (result.dismiss === "cancel") {
          this.message(
            this.$t(this.label(`${translationKey}.canceledTitle`)),
            this.$t(this.label(`${translationKey}.canceledText`)),
            "info",
          );
        }
        return;
      }

      showLoading();
      let statusUpdated = false;
      try {
        await serviceRequest(guid);
        await this.loadData();
        statusUpdated = true;
      } catch (error) {
        this.alertToast(
          "danger",
          this.$t("codeAlert"),
          error.message,
          "AlertTriangleIcon",
        );
      } finally {
        stopLoading();
      }

      if (statusUpdated) {
        await this.$swal({
          icon: "success",
          title: this.$t(this.label(`${translationKey}.successTitle`)),
          text: this.$t(this.label(`${translationKey}.successText`)),
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
    },
    onInfo() {},
    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },
    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>

<style lang="scss">
.per-page-selector {
  width: 90px;
}
.list-container {
  height: 60vh !important; /* Ajusta el alto según tus necesidades */
  overflow-y: auto;
}
</style>
